import React from 'react';
import { Button, Overlay, Text, Box, Group } from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  error,
  resetErrorBoundary,
}) => {
  return (
    <Overlay
      opacity={0.85}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '2rem',
      }}
    >
      <Box
        style={(theme) => ({
          backgroundColor: theme.colors.dark[7],
          padding: theme.spacing.xl,
          borderRadius: theme.radius.md,
          maxWidth: '30rem',
          width: '90%',
        })}
      >
        <IconExclamationCircle size={50} color="red" />
        <Text size="xl" fw={700} c="white" mb="md">
          Oops! Something went wrong.
        </Text>
        <Box
          mb="md"
          style={(theme) => ({
            border: '1px solid red',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: theme.spacing.md,
            borderRadius: theme.radius.xl,
          })}
        >
          <Text c="white" mb="md">
            Error: {error.message}
          </Text>
        </Box>
        <Text c="gray.4" mb="lg">
          Please try refreshing the page or click the button below to return to
          the dashboard.
        </Text>
        <Group align="center" justify="center">
          <Button variant="light" onClick={() => window.location.reload()}>
            Refresh
          </Button>
          <Button variant="light" onClick={resetErrorBoundary}>
            Dashboard
          </Button>
        </Group>
      </Box>
    </Overlay>
  );
};
